var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#002466"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3384 12.4248L18.47 8.55636C18.4186 8.50506 18.3577 8.46437 18.2906 8.43664C18.2235 8.4089 18.1516 8.39466 18.079 8.39471H11.4474C11.1543 8.39471 10.8732 8.51116 10.6659 8.71844C10.4586 8.92572 10.3422 9.20684 10.3422 9.49998V21.6579C10.3422 21.951 10.4586 22.2321 10.6659 22.4394C10.8732 22.6467 11.1543 22.7631 11.4474 22.7631H21.3948C21.6879 22.7631 21.9691 22.6467 22.1763 22.4394C22.3836 22.2321 22.5001 21.951 22.5001 21.6579V12.8158C22.5001 12.7432 22.4859 12.6713 22.4581 12.6042C22.4304 12.5371 22.3897 12.4761 22.3384 12.4248ZM18.6316 10.2813L20.6135 12.2631H18.6316V10.2813ZM21.3948 21.6579H11.4474V9.49998H17.5264V12.8158C17.5264 12.9623 17.5846 13.1029 17.6882 13.2065C17.7919 13.3102 17.9324 13.3684 18.079 13.3684H21.3948V21.6579ZM19.1843 16.1316C19.1843 16.2781 19.126 16.4187 19.0224 16.5223C18.9188 16.626 18.7782 16.6842 18.6316 16.6842H14.2106C14.064 16.6842 13.9235 16.626 13.8198 16.5223C13.7162 16.4187 13.658 16.2781 13.658 16.1316C13.658 15.985 13.7162 15.8444 13.8198 15.7408C13.9235 15.6371 14.064 15.5789 14.2106 15.5789H18.6316C18.7782 15.5789 18.9188 15.6371 19.0224 15.7408C19.126 15.8444 19.1843 15.985 19.1843 16.1316ZM19.1843 18.3421C19.1843 18.4886 19.126 18.6292 19.0224 18.7329C18.9188 18.8365 18.7782 18.8947 18.6316 18.8947H14.2106C14.064 18.8947 13.9235 18.8365 13.8198 18.7329C13.7162 18.6292 13.658 18.4886 13.658 18.3421C13.658 18.1955 13.7162 18.055 13.8198 17.9513C13.9235 17.8477 14.064 17.7895 14.2106 17.7895H18.6316C18.7782 17.7895 18.9188 17.8477 19.0224 17.9513C19.126 18.055 19.1843 18.1955 19.1843 18.3421Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.743f1c9b8e3ad9e3576a1bedc9364e88.svg";
export { ForwardRef as ReactComponent };